import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Message } from 'primeng/api';
import { AppSettings } from '../../modules/shared/app.settings';
import { GoogleRoute } from '../../modules/shared/models/google-route.model';
import { UserCommonService } from '../../modules/shared/services/user-common.service';
declare const google: any;

@Component({
  selector: 'app-track-my-location',
  templateUrl: './track-my-location.component.html'
})

export class TrackMyLocationComponent implements OnInit, OnDestroy {
  map: any;
  marker;
  markers = [];
  maxRating = ['1', '2', '3', '4', '5'];
  locationDetails: any = null;
  bookingId;
  source;
  destination;
  current;
  liveLocationInterval;
  message: Message[] = [];
  tourStatus;
  tourStatusCode = 0;
  END_TRIP = 140;
  isMapPointChanged = false;
  isFromSource = true;
  profileImageUrl: string = AppSettings.GET_FILE_THUMB_URL;
  imageUrl = AppSettings.DEFAULT_PROFILE_IMAGE_URL;
  showTrackMyLocationPage = false;
  errorMessage = '';
  currentStatus: Number;
  constructor(
    private userCommonService: UserCommonService,
    private route: ActivatedRoute
  ) { }

  ngOnInit() {
    this.bookingId = this.route.snapshot.queryParams['id'];
    this.getLiveData();

    this.userCommonService.getTrackMyLocationDetails(this.bookingId).subscribe((result) => {
      this.showTrackMyLocationPage = true;
      this.locationDetails = result;
      this.tourStatus = result.tourBookingDetailsDto.tourBookingInfo.tourStatusString;
      this.tourStatusCode = result.tourBookingDetailsDto.tourBookingInfo.tourStatus;
      // this.imageUrl = this.profileImageUrl + result.tourBookingDetailsDto.driverInfo.profileImage;
      if (result.tourBookingDetailsDto.driverInfo.profileImage !== '' && result.tourBookingDetailsDto.driverInfo.profileImage !== null) {
        this.imageUrl = this.profileImageUrl + result.tourBookingDetailsDto.driverInfo.profileImage;
      }
      this.calculateAndDisplayRoute();
      this.map = new google.maps.Map(document.getElementById('trackLocationMap'), {
        center: this.destination,
        zoom: 6,
        gestureHandling: 'cooperative',
        zoomControl: true
      });
      this.trackLiveLocation();
    }, (reason) => {
      this.errorMessage = 'The page you are looking is not exist. Please contact to your Admin.';
    });

  }

  trackLiveLocation() {
    const trackLocationModel = this;
    if (this.tourStatusCode !== this.END_TRIP) {
      this.liveLocationInterval = setInterval(function() {
        trackLocationModel.getLiveData();
      }, 1000 * 15);
    }
  }

  ngOnDestroy() {
    clearInterval(this.liveLocationInterval);
  }

  getLiveData() {
    this.userCommonService.getTrackMyLiveLocation(this.bookingId).subscribe((result) => {
      this.source = new google.maps.LatLng(result.sourceLatitude, result.sourceLongitude);
      this.destination = new google.maps.LatLng(result.destinationLatitude, result.destinationLongitude);
      this.current = new google.maps.LatLng(result.driverLocationLatitude, result.driverLocationLongitude);
      this.tourStatus = result.tourStatusString;
      this.currentStatus = result.tourStatus;
      this.isMapPointChanged = (this.isFromSource !== result.trackFromsourse) ? true : false;
      this.isFromSource = result.trackFromsourse;
      this.upldateLocation();

    }, (reason) => {
    });
  }

  upldateLocation() {
    this.clearMarker();
    if (this.currentStatus !== AppSettings.BOOKING_STATUS.END_TRIP) {
      this.setMarker(this.map, this.current, 'driver');
    } else {
      this.calculateAndDisplayRoute();
      clearInterval(this.liveLocationInterval);

    }

    // this.setMarker(this.map, this.current, 'driver');
    if (!this.isFromSource) {
      this.setMarker(this.map, this.destination, 'destination');
    }
    this.setMarker(this.map, this.source, 'source');

    if (this.isMapPointChanged) {
      this.calculateAndDisplayRoute();
    }
  }

  calculateAndDisplayRoute() {

    const origin = this.currentStatus !== AppSettings.BOOKING_STATUS.END_TRIP ? this.current : this.source;
    const destination = this.isFromSource ? this.source : this.destination;

    const routeData: GoogleRoute = {
      "originLatitude": origin.lat(),
      "originLongitude": origin.lng(),
      "destinationLatitude": destination.lat(),
      "destinationLongitude": destination.lng(),
      "waypoints": []
    };

    this.userCommonService.getGoogleMapRoute(routeData).subscribe({
      next: (result) => {
        this.clearMarker();
        const decodedPath = this.userCommonService.decodePolyline(result.routes[0].polyline.encodedPolyline);
        const route = new google.maps.Polyline({
          path: decodedPath,
          geodesic: true,
          strokeColor: AppSettings.DEFAULT_ROUTE_COLOR,
          strokeOpacity: 1.0,
          strokeWeight: 3,
        });
        route.setMap(this.map);
        
        if (this.currentStatus !== AppSettings.BOOKING_STATUS.END_TRIP) {
          this.setMarker(this.map, this.current, 'driver');
        }
        if (!this.isFromSource) {
          this.setMarker(this.map, this.destination, 'destination');
        }
        this.setMarker(this.map, this.source, 'source');
      },
      error: (error) => {
        this.mapMessage('Failed to get route information');
      }
    });
  }

  setMarker(map, location, type) {
    let icon;
    switch (type) {
      case 'source':
        icon = '/assets/images/temp/Source.png';
        break;
      case 'destination':
        icon = '/assets/images/temp/Destination.png';
        break;
      default:
        icon = '/assets/images/temp/taxi_free.png';
        break;
    }

    this.marker = new google.maps.Marker;
    this.marker.setMap(map);
    this.marker.setIcon(icon);
    this.marker.setPosition(location);
    this.markers.push(this.marker);
  }

  clearMarker() {
    for (let marker = 0; marker < this.markers.length; marker++) {
      this.markers[marker].setMap(null);
    }
  }

  mapMessage(status) {
    this.message = [];
    this.message.push({ severity: 'success', summary: 'Confirmed', detail: status });
  }

}
